import { render, staticRenderFns } from "./EcommerceTotalSellerProductTable.vue?vue&type=template&id=5428c866&scoped=true&"
import script from "./EcommerceTotalSellerProductTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceTotalSellerProductTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceTotalSellerProductTable.vue?vue&type=style&index=0&id=5428c866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428c866",
  null
  
)

export default component.exports